import React from "react"

import { AppPrepaidAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { prepaid } from "@signals"


export default function PrepaidAutocomplete({ ...props }) {
    return <AppPrepaidAutocomplete
		value={prepaid.value}
		onChange={e => prepaid.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/payment_method`}
		{...props}
	/>
}